import React from "react";

// This hook returns an object containing the window's width and height.
// If executed server-side (no window object) the value of width and height will be undefined.
export function useWindowSize() {
  const isClient = typeof window === "object";

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }

  const [windowSize, setWindowSize] = React.useState(getSize);

  React.useEffect(() => {
    if (!isClient) {
      return () => {
        /* nothing to rid of */
      };
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };

    /* eslint-disable */
  }, []); // Empty array ensures that effect is only run on mount and unmount
  /* eslint-enable */

  return windowSize;
}
